/* eslint-disable react/no-unescaped-entities */
import { Link } from "react-router-dom";
import PageHeader from "@/components/PageHeader";
import { Reveal } from "@/components/Reveal";

const SECTIONS = [
  {
    n: "01",
    t: "Titolare del trattamento",
    body: (
      <>
        <p>
          Il Titolare del trattamento dei dati personali è <strong>Greenhouse Solutions SPA</strong>, con sede legale in
          Via Nino Bixio, 182 — 70043 Monopoli (BA), P. IVA 08671110727, REA BA-642120.
        </p>
        <p className="mt-3">
          Puoi contattare il Titolare in qualsiasi momento:
          email <a href="mailto:amministrazione@greenhousesolutionsspa.com" className="text-primary hover:underline">amministrazione@greenhousesolutionsspa.com</a> ·
          PEC <a href="mailto:greenhousesolutionsspa@pec.it" className="text-primary hover:underline">greenhousesolutionsspa@pec.it</a> ·
          tel. <a href="tel:+390805211927" className="text-primary hover:underline">080 521 1927</a>.
        </p>
      </>
    ),
  },
  {
    n: "02",
    t: "Dati trattati e finalità",
    body: (
      <>
        <h3 className="font-head font-bold text-lg mt-2 mb-2">a) Richiesta di preventivo</h3>
        <p>
          Tramite il modulo "Richiedi un preventivo" raccogliamo nome e cognome, telefono, email, località, servizio
          richiesto e descrizione dell'intervento. I dati sono utilizzati esclusivamente per ricontattarti, valutare la
          fattibilità, organizzare un sopralluogo ed elaborare un preventivo.
        </p>
        <h3 className="font-head font-bold text-lg mt-6 mb-2">b) Candidature di lavoro ("Lavora con noi")</h3>
        <p>
          Tramite il modulo di candidatura raccogliamo dati anagrafici e di contatto, mansione, esperienza, disponibilità,
          presentazione personale e, se lo alleghi, il Curriculum Vitae (PDF/DOC/DOCX). I dati sono utilizzati
          esclusivamente per valutare la candidatura e ricontattarti.
        </p>
        <p className="mt-3 border-l-2 border-primary pl-4">
          <strong>Importante:</strong> ti invitiamo a <strong>non inserire nel CV dati particolari</strong> (art. 9 GDPR) —
          ad esempio stato di salute, opinioni politiche o sindacali, convinzioni religiose — né altri dati non
          pertinenti alla candidatura. Qualora presenti, saranno cancellati senza essere trattati.
        </p>
        <h3 className="font-head font-bold text-lg mt-6 mb-2">c) Statistiche di navigazione</h3>
        <p>
          Il sito registra conteggi aggregati e anonimi (numero di visite alle pagine dei progetti e richieste inviate)
          per finalità statistiche interne. Non viene effettuata alcuna profilazione: non raccogliamo indirizzi IP a fini
          di analisi, non usiamo cookie di tracciamento né strumenti di analytics di terze parti.
        </p>
        <h3 className="font-head font-bold text-lg mt-6 mb-2">d) Area riservata</h3>
        <p>
          L'accesso all'area amministrativa richiede credenziali (email e password) riservate al personale autorizzato;
          i dati di accesso sono trattati per la sicurezza e la gestione del sito.
        </p>
      </>
    ),
  },
  {
    n: "03",
    t: "Base giuridica del trattamento",
    body: (
      <p>
        Il trattamento dei dati forniti tramite i moduli di preventivo e candidatura si fonda sull'esecuzione di
        <strong> misure precontrattuali</strong> adottate su richiesta dell'interessato (art. 6, par. 1, lett. b GDPR) e,
        per le candidature, sull'interesse legittimo del Titolare a valutare professionisti da inserire in organico.
        Le statistiche aggregate e anonime si fondano sull'interesse legittimo (art. 6, par. 1, lett. f GDPR) a migliorare
        i contenuti del sito. Per questo tipo di trattamenti <strong>non è richiesto il consenso</strong>.
      </p>
    ),
  },
  {
    n: "04",
    t: "Tempi di conservazione",
    body: (
      <>
        <p>
          <strong>Richieste di preventivo:</strong> i dati sono conservati per il tempo necessario a gestire la richiesta
          e, in caso di incarico, per la durata del rapporto contrattuale e dei termini di legge (civili e fiscali); in
          assenza di incarico, al massimo 12 mesi dalla richiesta.
        </p>
        <p className="mt-3">
          <strong>Candidature e CV:</strong> conservati per un massimo di 12 mesi dall'invio, salvo instaurazione del
          rapporto di lavoro o tua richiesta di cancellazione anticipata.
        </p>
        <p className="mt-3">
          <strong>Cancellazione automatica:</strong> decorsi i termini sopra indicati, i dati vengono eliminati
          automaticamente dai nostri sistemi entro ulteriori 30 giorni (periodo tecnico di grazia), compresi gli
          eventuali CV allegati. Ogni cancellazione automatica è registrata in un apposito registro, senza conservare
          i dati personali eliminati.
        </p>
      </>
    ),
  },
  {
    n: "05",
    t: "Destinatari e fornitori tecnici",
    body: (
      <>
        <p>
          I dati non sono venduti né ceduti a terzi. Possono essere trattati, in qualità di responsabili o fornitori
          tecnici, da: il fornitore di hosting e infrastruttura cloud del sito, il servizio di invio email
          transazionale utilizzato per le notifiche, e i consulenti del Titolare (amministrativi, fiscali, legali)
          nei limiti delle rispettive competenze.
        </p>
        <p className="mt-3">
          L'elenco aggiornato dei responsabili è disponibile su richiesta scrivendo al Titolare.
        </p>
      </>
    ),
  },
  {
    n: "06",
    t: "Trasferimenti fuori dall'UE",
    body: (
      <p>
        Alcuni fornitori tecnici (infrastruttura cloud, servizio email) possono trattare dati anche al di fuori dello
        Spazio Economico Europeo; in tal caso il trasferimento avviene nel rispetto degli artt. 44 e ss. GDPR, sulla
        base di decisioni di adeguatezza o clausole contrattuali standard approvate dalla Commissione Europea.
        Tutti i contenuti del sito (font, immagini, script) sono ospitati direttamente sui nostri sistemi:
        la navigazione non comporta il trasferimento automatico di dati a CDN o servizi di terze parti.
      </p>
    ),
  },
  {
    n: "07",
    t: "Cookie e strumenti di tracciamento",
    body: (
      <p>
        Questo sito <strong>non utilizza cookie di profilazione</strong> né cookie di terze parti per finalità di
        marketing o analisi. Viene utilizzata esclusivamente memoria tecnica del browser (localStorage/sessionStorage)
        strettamente necessaria al funzionamento: ad esempio per non conteggiare due volte la stessa visita a un
        progetto e per mantenere la sessione dell'area riservata. Per questo motivo non è richiesto alcun banner
        per i cookie.
      </p>
    ),
  },
  {
    n: "08",
    t: "Link e servizi esterni",
    body: (
      <p>
        Il sito contiene collegamenti a servizi esterni — WhatsApp, LinkedIn, Facebook, Instagram e le vetrine dei
        partner (PA Card, inprimePay). Cliccando su questi collegamenti si accede a piattaforme di terzi, che trattano
        i dati secondo le rispettive informative privacy, che ti invitiamo a consultare. Greenhouse Solutions SPA non
        risponde del trattamento effettuato da tali piattaforme.
      </p>
    ),
  },
  {
    n: "09",
    t: "I tuoi diritti",
    body: (
      <>
        <p>
          In qualsiasi momento puoi esercitare i diritti previsti dagli artt. 15-22 GDPR: <strong>accesso</strong> ai
          tuoi dati, <strong>rettifica</strong>, <strong>cancellazione</strong>, <strong>limitazione</strong> del
          trattamento, <strong>opposizione</strong> e <strong>portabilità</strong> ove applicabile.
        </p>
        <p className="mt-3">
          Per esercitarli scrivi a <a href="mailto:amministrazione@greenhousesolutionsspa.com" className="text-primary hover:underline">amministrazione@greenhousesolutionsspa.com</a>.
          Hai inoltre diritto di proporre reclamo all'autorità di controllo: <strong>Garante per la protezione dei
          dati personali</strong> (<a href="https://www.garanteprivacy.it" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">www.garanteprivacy.it</a>).
        </p>
      </>
    ),
  },
  {
    n: "10",
    t: "Modifiche a questa informativa",
    body: (
      <p>
        Il Titolare può aggiornare la presente informativa in qualsiasi momento; la versione vigente è quella
        pubblicata su questa pagina. <strong>Ultimo aggiornamento: luglio 2026.</strong>
      </p>
    ),
  },
];

export default function Privacy() {
  return (
    <div data-testid="privacy-page" className="bg-background">
      <PageHeader
        index="Legal"
        title="Privacy"
        lines={["Informativa", "privacy."]}
        subtitle="Come Greenhouse Solutions SPA raccoglie, utilizza e protegge i tuoi dati personali, ai sensi del Regolamento (UE) 2016/679 (GDPR) e del D.Lgs. 196/2003 come novellato."
        logo
      />

      <section className="pb-24 md:pb-32 bg-background" data-testid="privacy-content">
        <div className="max-w-[1500px] mx-auto px-5 md:px-10">
          <div className="max-w-3xl space-y-14">
            {SECTIONS.map((s) => (
              <Reveal key={s.n}>
                <article data-testid={`privacy-section-${s.n}`} className="border-t border-border pt-8">
                  <div className="font-mono text-xs uppercase tracking-widest text-primary mb-3 flex items-center gap-3">
                    <span>{s.n}</span>
                    <span className="w-10 h-px bg-primary" />
                  </div>
                  <h2 className="font-head font-black text-2xl md:text-3xl tracking-tightest mb-4">{s.t}</h2>
                  <div className="text-muted-foreground leading-relaxed text-sm md:text-base">{s.body}</div>
                </article>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.1}>
            <p className="mt-16 max-w-3xl text-xs text-muted-foreground font-mono uppercase tracking-widest">
              Domande sul trattamento dei dati? Scrivici dalla pagina{" "}
              <Link to="/contatti" className="text-foreground hover:text-primary transition-colors">Contatti</Link>.
            </p>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
